import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import functions from '../../../../utils/functions';
import PopTicketConvert from './PopTicketConvert';

class ConvertTicket extends Component {

    state={
        mdl:false
    }

    handleClick=()=>{
        this.setState({
            mdl:false
        }, ()=>{
            this.setState({
                mdl:<PopTicketConvert {...this.props}/>
            }, ()=>{
                functions.openPopup("modal_ticket_convert")
            })
           
        })
    }


    render() {
        return (
            <>
            {this.state.mdl}
            <Link to="#" className="card-link" onClick={this.handleClick}>
            <i className="fas fa-tag tx-danger mr-1"/>
            Exchange Paper Ticket
        </Link>
        </>
        );
    }
}

export default ConvertTicket;